import { useState, useContext } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import _get from 'lodash/get';

import { RoleDocument } from 'commons/models/marketingDashboard';
import { AppContext } from 'commons-ui';

import useService from '../../utils/useService';
import { hydrateFormData, dehydrateFormData } from '../../utils/formDataParser';
import { IRolesFormData } from '../../utils/constants';

const useEdit = () => {
	const [showLoader, setShowLoader] = useState(false);
	const { showAlert, app } = useContext(AppContext);
	const history = useHistory();
	const location = useLocation();
	const { requestUpdateRole } = useService();

	const data = hydrateFormData(_get(location, ['state', 'rowData']));

	const updateRole = async (updatedData: RoleDocument) => {
		setShowLoader(true);

		try {
			await requestUpdateRole(app.appName, updatedData);
			showAlert('Role updated successfully', { type: 'success' });
			setShowLoader(false);
			history.goBack();
		} catch (e: any) {
			showAlert(e.response?.data?.error ?? 'Error while updating the role', { type: 'error' });
			setShowLoader(false);
		}
	};

	const handleFormSubmit = (updatedData: IRolesFormData) => {
		updateRole(dehydrateFormData(updatedData));
	};

	const handleFormCancel = () => {
		history.goBack();
	};

	return { data, showLoader, handleFormSubmit, handleFormCancel, setShowLoader };
};

export default useEdit;
